/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A folder for organizing documents within a claim. Supports nesting via parentId.
 * @export
 * @interface DocumentFolder
 */
export interface DocumentFolder {
    /**
     * 
     * @type {number}
     * @memberof DocumentFolder
     */
    readonly id: number;
    /**
     * 
     * @type {number}
     * @memberof DocumentFolder
     */
    claimId: number;
    /**
     * 
     * @type {number}
     * @memberof DocumentFolder
     */
    companyId: number;
    /**
     * Parent folder ID. Null means root-level folder.
     * @type {number}
     * @memberof DocumentFolder
     */
    parentId?: number | null;
    /**
     * Folder name
     * @type {string}
     * @memberof DocumentFolder
     */
    name: string;
    /**
     * Optional hex color code (e.g. #3B82F6)
     * @type {string}
     * @memberof DocumentFolder
     */
    color?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DocumentFolder
     */
    createdBy: number;
    /**
     * 
     * @type {number}
     * @memberof DocumentFolder
     */
    readonly documentCount?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof DocumentFolder
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof DocumentFolder
     */
    readonly updatedAt: Date;
}

/**
 * Check if a given object implements the DocumentFolder interface.
 */
export function instanceOfDocumentFolder(value: object): value is DocumentFolder {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('claimId' in value) || value['claimId'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('createdBy' in value) || value['createdBy'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function DocumentFolderFromJSON(json: any): DocumentFolder {
    return DocumentFolderFromJSONTyped(json, false);
}

export function DocumentFolderFromJSONTyped(json: any, ignoreDiscriminator: boolean): DocumentFolder {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'claimId': json['claimId'],
        'companyId': json['companyId'],
        'parentId': json['parentId'] == null ? undefined : json['parentId'],
        'name': json['name'],
        'color': json['color'] == null ? undefined : json['color'],
        'createdBy': json['createdBy'],
        'documentCount': json['documentCount'] == null ? undefined : json['documentCount'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}

export function DocumentFolderToJSON(json: any): DocumentFolder {
    return DocumentFolderToJSONTyped(json, false);
}

export function DocumentFolderToJSONTyped(value?: Omit<DocumentFolder, 'id'|'documentCount'|'createdAt'|'updatedAt'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'claimId': value['claimId'],
        'companyId': value['companyId'],
        'parentId': value['parentId'],
        'name': value['name'],
        'color': value['color'],
        'createdBy': value['createdBy'],
    };
}

